import * as cx from 'classnames';
import * as React from 'react';
import styles from './StarsRating.mscss';

interface OwnProps {
    starsCount: number;
    label?: string;
    className?: string;
    classNames?: {  // classNames for inner components
        stars?: string;
        label?: string;
    };
}

export default class StarsRating extends React.Component<OwnProps> {
    public render() {
        const {starsCount, label, className, classNames} = this.props;

        return (
            <div className={cx(styles.StarsRating, className)}>
                {label ?
                    <div className={cx(styles.StarsRating__label, classNames && classNames.label)}>
                        {label}
                    </div> : null
                }
                <div className={cx(styles.StarsRating__starsWrapper, classNames && classNames.stars)}>
                    {starsCount >= 1 ?
                        <i className={cx('fa', 'fa-star', styles['StarsRating__starsWrapper--gold'])}/> :
                        <i className={cx('fa', 'fa-star-o')}/>}
                    {starsCount >= 2 ?
                        <i className={cx('fa', 'fa-star', styles['StarsRating__starsWrapper--gold'])}/> :
                        <i className={cx('fa', 'fa-star-o')}/>}
                    {starsCount >= 3 ?
                        <i className={cx('fa', 'fa-star', styles['StarsRating__starsWrapper--gold'])}/> :
                        <i className={cx('fa', 'fa-star-o')}/>}
                    {starsCount >= 4 ?
                        <i className={cx('fa', 'fa-star', styles['StarsRating__starsWrapper--gold'])}/> :
                        <i className={cx('fa', 'fa-star-o')}/>}
                    {starsCount >= 5 ?
                        <i className={cx('fa', 'fa-star', styles['StarsRating__starsWrapper--gold'])}/> :
                        <i className={cx('fa', 'fa-star-o')}/>}
                </div>
            </div>
        );
    }
}
